module.exports = __webpack_public_path__ + "img/legend_c.54109d20.png";